export enum RequestStatus {
    ACTIVE = 'active',
    COMPLETED = 'completed',
    ERROR = 'error',
    PENDING = 'pending'
}
